import { HttpParams } from '@angular/common/http';

interface InputParamsInterface {
  [param: string]: string | ReadonlyArray<string>;
}

export enum InstrumentTypeEnum {
  STOCK = 'Stock',
  ETF = 'ETF',
  INDEX = 'Index',
  FX_INDEX = 'FX Index',
  FUTURE = 'Future root'
}

export default class Utils {

  static getToken() {
    return sessionStorage.getItem('token');
  }

  static setToken(token: string) {
    sessionStorage.setItem('token', token);
  }

  static getUserId() {
    return sessionStorage.getItem('userId');
  }

  static getUserUuid() {
    return sessionStorage.getItem('uuid');
  }

  static setUser(user) {
    sessionStorage.setItem('uuid', user.uuid);
    sessionStorage.setItem('userId', user.id);
  }

  static downloadFile(data, fileName) {
    const link = document.createElement('a');
    const blob = new Blob([data], {type: 'text/csv'});
    const objectURL = window.URL.createObjectURL(blob);
    link.href = objectURL;
    link.download = fileName + '.csv';
    const clickEvent = new MouseEvent('click', {'view': window, 'bubbles': true, 'cancelable': true});
    link.dispatchEvent(clickEvent);
    window.URL.revokeObjectURL(objectURL);
  }

  static getError(type: string, message: string) {
    const error = new Error(message);
    error.name = type;
    return error;
  }

  static getStockType(item: any): InstrumentTypeEnum {
    const type = item.stockType || item.instrumentType || '';

    if (item.underlyingId) {
      return InstrumentTypeEnum.FUTURE;
    }

    switch (type.toUpperCase()) {
      case 'S':
        return InstrumentTypeEnum.STOCK;
      case 'F':
        return InstrumentTypeEnum.ETF;
      case 'I':
        return InstrumentTypeEnum.INDEX;
      case 'X':
        return InstrumentTypeEnum.FX_INDEX;
      default:
        return null;
    }
  }

  static isMobile() {
    let check = false;
    (function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4))) {
        check = true;
      }
    })(navigator.userAgent || navigator.vendor);
    return check;
  }

  static get isMac(): boolean {
    return !!navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i);
  }

  static mask() {
    Utils._setMask(true);
  }

  static unmask() {
    Utils._setMask(false);
  }

  private static _setMask(isMasked) {
    document.getElementById('main').style.display = isMasked ? 'block' : 'none';
  }
}

export function getHttpParams(args: InputParamsInterface): HttpParams {
  for (const argsKey in args) {
    if (!args[argsKey]) {
      delete args[argsKey];
    }
  }

  return new HttpParams({
    fromObject: args
  });
}

export function adoptTipPosition(tip: HTMLElement) {
  tip.style.right = '';
  tip.style.left = '';

  const windowWidth: number = (window.innerWidth || document.documentElement.clientWidth);
  const rect: DOMRect = tip.getBoundingClientRect();

  const overflowDirection: { left: boolean; right: boolean } = {
    right: rect.right > windowWidth,
    left: rect.left < 0
  };

  tip.style.right = overflowDirection.right ? `calc(100% - 10px)` : '';
  tip.style.left = overflowDirection.left ? `calc(100% - 10px)` : '';
}
